/* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage */
import React from 'react';

import Icon, { type CustomGlyphProps } from '@atlaskit/icon';
import type { IconProps, NewIconProps } from '@atlaskit/icon';
import TextLengthenIcon from '@atlaskit/icon-lab/core/text-lengthen';
import { fg } from '@atlaskit/platform-feature-flags';

// Ignored via go/ees007
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// FIXME: When "@atlaskit/icon-lab/text-lengthen" icon is available via the icons package we should replace this
const CustomGlyph = (props: CustomGlyphProps) => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		// Ignored via go/ees005
		// eslint-disable-next-line react/jsx-props-no-spreading
		{...props}
	>
		<path
			d="M1 2.75L15 2.75M1 5.91667L8 5.91667M1 10.0833L15 10.0833M1 13.25L8 13.25"
			stroke="currentColor"
			strokeWidth="1.5"
		/>
	</svg>
);

const TextBreakIcon = (
	props: Exclude<IconProps, 'glyph' | 'size'> & {
		color?: NewIconProps['color'];
		size?: NewIconProps['size'];
	},
): React.JSX.Element => {
	const { color } = props;
	return fg('platform-custom-icon-migration') ? (
		// eslint-disable-next-line react/jsx-props-no-spreading
		<TextLengthenIcon {...props} />
	) : (
		// Ignored via go/ees007
		// eslint-disable-next-line @atlaskit/design-system/no-custom-icons
		<Icon
			glyph={CustomGlyph}
			primaryColor={color}
			// Ignored via go/ees005
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...props}
		/>
	);
};

export default TextBreakIcon;
